/** Matches `.reflex-container.horizontal > .reflex-splitter` height. */
export const FLEX_LAYOUT_SPLITTER_SIZE = 3;

export type FlexLayoutPaneFlex = {
  upperFlex?: number;
  lowerFlex?: number;
};

const paneFlexFromShare = (upperFlex: number): FlexLayoutPaneFlex => ({
  upperFlex,
  lowerFlex: 1 - upperFlex,
});

/**
 * Converts an upper-pane pixel height into a share of the parent container.
 * react-reflex treats `size` as a maximum, so a pane taller than 50% of the
 * container would otherwise fall back to an even split. `flex` is the actual share.
 */
export const resolveFlexLayoutPaneFlex = (
  upperPaneSize: number | undefined,
  containerSize: number,
): FlexLayoutPaneFlex => {
  if (!upperPaneSize || upperPaneSize <= 0 || containerSize <= 0) {
    return {};
  }

  const minPaneSize = 1;
  const availableSize = containerSize - FLEX_LAYOUT_SPLITTER_SIZE;
  if (availableSize <= minPaneSize * 2) {
    return {};
  }

  const clampedUpper = Math.min(Math.max(upperPaneSize, minPaneSize), availableSize - minPaneSize);
  return paneFlexFromShare(clampedUpper / availableSize);
};

/** Restores pane flex from a parent-relative share (0–1, exclusive). */
export const resolveSavedPaneFlex = (upperPaneFlex: number | undefined): FlexLayoutPaneFlex => {
  if (typeof upperPaneFlex === 'number' && upperPaneFlex > 0 && upperPaneFlex < 1) {
    return paneFlexFromShare(upperPaneFlex);
  }
  return {};
};
